export default "__VITE_PUBLIC_ASSET__97dcc242__"